import { type Control, Controller } from 'react-hook-form';

import { CalendarWrapper as Calendar } from '@/components/common/calendar-wrapper';

import { useBulkDonorSchedulingStore } from '../hooks/use-bulk-donor-scheduling-store';
import type { BulkDonorScheduleFieldsInput } from '../utils/schema';

export function AspirationDate({
  className,
  control,
  disabled,
  valueChanged,
}: {
  className?: string;
  control: Control<BulkDonorScheduleFieldsInput>;
  disabled?: boolean;
  valueChanged: () => void;
}) {
  const [state] = useBulkDonorSchedulingStore();
  return (
    <Controller
      control={control}
      name="aspirationDate"
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { error },
      }) => {
        const message = state.messages?.[name];
        const sheetError = state.errors?.[name];
        return (
          <div>
            <Calendar
              className={className}
              placeholder="Aspiration Date"
              onBlur={onBlur}
              name={name}
              inputRef={ref}
              value={value}
              minDate={new Date()}
              onChange={(e) => {
                if (e.value instanceof Date) {
                  onChange(e.value);
                  valueChanged();
                }
              }}
              showIcon
              dateFormat="mm/dd/yy"
              showOnFocus={false}
              disabled={disabled}
              invalid={!!error?.message || !!sheetError}
            />

            {error?.message || sheetError ? (
              <p className="mt-2 mb-0 text-red-500">
                {error?.message ?? sheetError}
              </p>
            ) : null}
            {message ? (
              <p className="mt-2 mb-0 text-emerald-500">{message}</p>
            ) : null}
          </div>
        );
      }}
    />
  );
}
